<template>
  <div class="text-left fp-nav-map h-full clearfix w">
    <div class="text-center content-title">
      <span class="inline-block line-css"></span>
      <span v-if="type === 'page' && position !== 'home'" class="font-css">
        <span>导览地图</span> TOURIST MAP
      </span>
      <span v-else class="font-css">
        <span>全景御窑</span> IMPERIAL KILN PANORAMIC
      </span>
      <span class="inline-block line-css"></span>
    </div>
    <div
      :class="
        type === 'page'
          ? 'nav-map-img nav-map-img-page relative w-2/5'
          : 'nav-map-img w-1/3'
      "
    >
      <div class="navigator-url relative w-full h-full" :style="rootBg">
        <ul v-if="points && root.height && root.width">
          <template v-for="point in points">
            <li
              :key="point.id"
              class="point-css absolute cursor-pointer"
              :style="
                `top:${(point.coordinate.y / root.height) * 100}%; left:${(point
                  .coordinate.x /
                  root.width) *
                  100}%`
              "
              :data-id="point.id"
              @click="pointChange"
              v-if="
                point.coordinate &&
                  typeof point.coordinate.x === 'number' &&
                  typeof point.coordinate.y === 'number'
              "
            >
              <div
                v-if="pointActive === point.id"
                class="loader-inner ball-scale-ripple-multiple"
              >
                <div></div>
                <div></div>
                <div></div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div
      class="nav-map-info h-full w-2/3 cursor-default float-left relative"
      v-if="points && type !== 'page'"
    >
      <div class="clearfix ">
        <span class="float-left nav-map-title">导览地图&emsp;TOURIST MAP</span>
        <div
          class="more float-right"
          @click="
            link({
              type: 'link',
              link: '/panorama',
              category: 'panorama'
            })
          "
        >
          更多 | MORE
        </div>
      </div>
      <transition-group name="info" class="absolute info-content">
        <template v-for="point in points">
          <div :key="`poi-${point.pano_no}`" v-if="point.id === pointActive">
            <div class="nav-map-info-title">
              {{ point.pano_no }} {{ point.name }}
            </div>
            <div class="nav-map-info-description">{{ point.description }}</div>
          </div>
        </template>
      </transition-group>
    </div>
    <div
      :class="
        position && position === 'home'
          ? 'nav-map-info h-full w-3/5 cursor-default float-left relative page-css home-css'
          : 'nav-map-info h-full w-3/5 cursor-default float-left relative page-css'
      "
      v-else-if="points && type === 'page'"
    >
      <transition-group name="info" class="info-content">
        <template v-for="point in points">
          <div :key="`poi-${point.pano_no}`" v-if="point.id === pointActive">
            <div
              class="more see-more more-deep absolute"
              @click="
                link({
                  type: 'link',
                  link: '/panorama/h5',
                  category: 'panorama',
                  query: { pano_no: point.pano_no }
                })
              "
            >
              <span class="align-top">全景观赏</span>
              <i class="iconfont icon-see"></i>
            </div>
            <div class="nav-map-info-title">{{ point.name }}</div>
            <ul class="nav-map-info-description">
              <li v-if="point.video && point.video.video_url" class="relative">
                <div class="w-full inline-block">
                  <i class="s-circular"></i>
                  <span class="info-title">相关视频</span>
                  <div class="info-css w-full clearfix">
                    《{{ point.video.title }}》
                  </div>
                </div>
                <div class="more more-deep absolute" @click="videoPlay(point)">
                  <span class="align-top">点击播放</span>
                  <i class="iconfont icon-play"></i>
                </div>
              </li>
              <li
                v-if="
                  point.models &&
                    (point.models.length > 1 ||
                      (point.models.length === 1 &&
                        point.models[0].type !== 'current'))
                "
                class="relative pt-2 pb-4"
              >
                <div class="w-full inline-block">
                  <i class="s-circular"></i>
                  <span class="info-title">语音讲解</span>
                  <!-- <div class="info-css w-full clearfix">
                    {{ point.name }}讲解
                  </div> -->
                </div>

                <!-- <div
                  :class="
                    showAudio
                      ? 'more more-deep absolute active'
                      : 'more more-deep absolute'
                  "
                  @click="showAudio = !showAudio"
                >
                  <span class=" align-top">点击讲解</span>
                  <i class="iconfont icon-audio"></i>
                </div> -->

                <div :style="briefAudio || detailAudio ? '' : 'display:none'">
                  <!-- <div class="btn-hover" @click="startPlayOrPause">
                    <i id="audioBtn" class="btns btns-audio0 inline-block" />

                    <span
                      class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
                    >
                      语音讲解
                    </span>
                  </!-->

                  <div
                    :class="
                      showAudio
                        ? 'more more-deep absolute active'
                        : 'more more-deep absolute'
                    "
                    @click="startPlayOrPause"
                  >
                    <span class=" align-top">点击讲解</span>
                    <i id="audioBtn" class="iconfont icon-audio"></i>
                  </div>

                  <Player
                    v-if="
                      (briefAudio || detailAudio) &&
                        !(briefAudio && detailAudio)
                    "
                    style="display:none;"
                    class="audio-bar"
                    ref="audioRef"
                    :sources="[
                      (briefAudio && briefAudio.path_url) ||
                        (detailAudio && detailAudio.path_url)
                    ]"
                    :setting="[{ name: 'audioBar', value: true }]"
                    :value="true"
                    :data="briefAudio || detailAudio"
                    :xhrWithCredentials="true"
                  ></Player>
                  <AudioBar
                    v-if="briefAudio && detailAudio"
                    class="audio-bar"
                    ref="refAudio"
                    :showAudio.sync="showAudio"
                    :data="[briefAudio, detailAudio]"
                  />
                </div>

                <!-- <transition name="audio">
                  <ul v-if="showAudio" class="absolute audio-lists">
                    <li
                      v-for="item in point.models"
                      :key="item.id"
                      :class="audioListClass(item)"
                    >
                      <Player
                        :ref="`${item.type}Ref`"
                        :sources="[item.path_url]"
                        :value="true"
                        :data="item"
                        :xhrWithCredentials="true"
                      ></Player>
                    </li>
                  </ul>
                </transition> -->
              </li>
              <li
                v-if="
                  point.locations &&
                    point.locations.length !== 0 &&
                    point.ceramic_exists
                "
                class="relative pt-2 pb-4"
              >
                <div class="w-full inline-block">
                  <i class="s-circular"></i>
                  <span class="info-title">出土瓷器</span>
                  <!-- <div class="info-css w-full clearfix">
                    出土于：{{ point.locations.join('，') }} 的瓷器
                  </div> -->
                </div>
                <div
                  class="more more-deep absolute"
                  @click="
                    link(
                      {
                        type: 'link',
                        link: '/ceramic',
                        query: { location: point.locations }
                      },
                      'windowOpen'
                    )
                  "
                >
                  <span class="align-top">点击查看</span>
                  <i class="iconfont icon-Add"></i>
                </div>
              </li>
              <li class="introduce">
                <div class="w-full inline-block">
                  <i class="s-circular"></i>
                  <span class="info-title">景点介绍</span>
                  <div class="info-css w-full clearfix">
                    {{ point.content_text }}
                  </div>
                </div>
              </li>
            </ul>
            <div class="w-full clearfix absolute next-prev-btns">
              <div
                v-if="pointActiveIndex !== 0"
                class="float-left cursor-pointer prev"
                data-prev="prev"
                @click="pointChange"
              >
                上一处景点
              </div>
              <div
                v-if="pointActiveIndex !== points.length - 1"
                class="float-right cursor-pointer next"
                data-next="next"
                @click="pointChange"
              >
                下一处景点
              </div>
            </div>
          </div>
        </template>
      </transition-group>
    </div>

    <div v-else class="text-center no-data nav-map-info">暂无数据</div>
    <div v-if="showVideo" class="relative">
      <div class="modal-close" @click="showVideo = false"></div>
      <VideoPlayer
        class="video-css"
        :data="videoData"
        :autoplay="true"
        type="video"
      ></VideoPlayer>
    </div>

    <Masker :show.sync="showVideo"></Masker>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import VideoPlayer from '@/components/common/Video'
import Masker from '@/components/common/Mask'
import Player from '@/components/common/Player'
import AudioBar from '@/components/common/AudioBar'

export default {
  name: 'panoramas-nav',
  props: {
    type: null,
    position: null
  },
  mixins: [link],
  components: {
    Player,
    AudioBar,
    Masker,
    VideoPlayer
  },
  data() {
    return {
      root: {
        url: null,
        width: null,
        height: null
      },
      points: null,
      pointActive: null,
      showAudio: false,
      showVideo: false,
      videoData: null
      // modals: ['showNavMap', 'showInfo', 'showAudio', 'showVideo', 'showPoi'] // 导览图 简介 音频 视频 出土文物 poi简介
    }
  },
  computed: {
    panoramas() {
      if (!this.$store.getters['PanoramasStore/panoramas']) {
        return { children: [] }
      }
      let result = Object.values(
        this.$store.getters['PanoramasStore/panoramas']
      )
      return result.length > 0 ? result[0] : { children: [] }
    },
    rootBg() {
      return this.root.url ? `background-image:url(${this.root.url});` : ''
    },
    pointActiveIndex() {
      let thisIndex
      this.points.forEach((item, index) => {
        if (this.pointActive === item.id) {
          thisIndex = index
        }
      })
      return thisIndex
    },
    detailAudio() {
      let point = this.points.filter(item => item.id === this.pointActive)
      if (!point || point.length === 0) {
        return false
      }
      point = point[0]
      if (!point || !point.models || point.models.length === 0) {
        return false
      }
      return point.models.filter(modal => {
        return modal.type === 'detail'
      })[0]
    },
    briefAudio() {
      let point = this.points.filter(item => item.id === this.pointActive)
      if (!point || point.length === 0) {
        return false
      }
      point = point[0]
      if (!point || !point.models || point.models.length === 0) {
        return false
      }
      return point.models.filter(modal => {
        return modal.type === 'brief'
      })[0]
    }
  },
  watch: {
    panoramas: {
      immediate: true,
      handler(val) {
        if (val.navigator_url) {
          this.root.url = val.navigator_url
          this.root.width = val.navigator_width
          this.root.height = val.navigator_height
          this.points =
            val.children && val.children.length > 0
              ? val.children.filter(
                  point => point.type === 'panorama' && point.visible === 1
                )
              : null
          this.pointActive =
            this.points && this.points[0] ? this.points[0].id : null
        }
      }
    }
  },
  mounted() {
    this.carousel()
  },
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause() {
      if (
        (this.briefAudio || this.detailAudio) &&
        !(this.briefAudio && this.detailAudio)
      ) {
        // this.$refs.audioRef.loop = true
        this.$refs.audioRef[0].togglePlayback()

        let i = 0
        let audioBtn = document.getElementById('audioBtn')
        let timer = setInterval(() => {
          // this.audioBtn = i
          audioBtn.classList.remove('icon-audio')
          audioBtn.classList.remove('icon-audio1')
          audioBtn.classList.remove('icon-audio2')
          audioBtn.classList.remove('icon-audio3')
          if (i === 0) {
            audioBtn.classList.add('icon-audio')
          } else {
            audioBtn.classList.add('icon-audio' + i)
          }

          if (i === 2) {
            i = -1
          }
          i++
          let timer1 = setTimeout(() => {
            clearTimeout(timer1)
            if (
              !this.$refs.audioRef ||
              (this.$refs.audioRef[0] && !this.$refs.audioRef[0].playing)
            ) {
              clearInterval(timer)
              if (audioBtn) {
                audioBtn.classList.remove('icon-audio')
                audioBtn.classList.remove('icon-audio1')
                audioBtn.classList.remove('icon-audio2')
                audioBtn.classList.remove('icon-audio3')
                audioBtn.classList.add('icon-audio')
              }
            }
          }, 300)
        }, 600)
      } else if (this.briefAudio && this.detailAudio) {
        // 显示音频
        this.$set(this, 'showAudio', !this.showAudio)
      }
    },
    videoPlay(point) {
      this.showVideo = true
      this.videoData = point.video
    },
    audioListClass(item) {
      let className = 'relative '
      if (item.type === 'detail') {
        className += 'detail-css'
      } else if (item.type === 'brief') {
        className += 'brief-css'
      } else {
        className += 'hidden'
      }

      return className
    },
    pointChange(e) {
      this.showAudio = false
      if (e.target.dataset.id) {
        this.pointActive = e.target.dataset.id
      } else {
        if (e.target.dataset.next) {
          this.pointActive = this.points[this.pointActiveIndex + 1].id
        } else if (e.target.dataset.prev) {
          this.pointActive = this.points[this.pointActiveIndex - 1].id
        }
      }
    },
    carousel() {
      /*设置定时器运行的函数*/
      // let num = -1
      // setInterval(() => {
      //   if (!this.points) {
      //     return
      //   }
      //   num++
      //   let pLength = this.points.length
      //   this.pointActive = this.points[num % pLength].id
      // }, 30000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.info-enter-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}
.info-enter,
.info-leave-to {
  opacity: 0;
}

.fp-nav-map {
  color: $c-white;
}

.video-css {
  ::v-deep  div {
    z-index: 102;
  }
}
.nav-map-title {
  font-size: 22px;
}
.nav-map-img {
  height: 500px;
  float: left;
  img {
    display: none;
    width: 100%;
    height: 100%;
  }
}
.nav-map-img-page {
  height: 724px;
}
.navigator-url {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.point-css {
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: $c-red;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}
.home-css.page-css.nav-map-info,
.nav-map-info {
  background-color: $c-tour-bg-blue;
  background-image: url('../../../static/images/tour/bg-flower-b.png');
  background-repeat: no-repeat;
  background-size: auto 600px;
  background-position: 405px 75px;
}
.home-css {
  .more-deep {
    &:hover,
    &.active {
      color: $c-hover;
      border: 1px solid $c-hover;
    }
  }
}
.nav-map-info {
  height: 500px;
  padding: 24px 22px 0 38px;
  .info-content {
    bottom: 0;
    left: 0;
    padding: 32px 38px;
    padding-right: 150px;
  }
  .nav-map-info-title {
    font-size: 26px;
    line-height: 1;
    margin-bottom: 18px;
    padding-left: 3px;
  }
  .nav-map-info-description {
    color: $c-white;
    line-height: 2.2;
    font-size: 14px;
    overflow: hidden;
    -o-text-overflow: ellipsis; /* Opera 9-10 */
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
}
.page-css.nav-map-info {
  height: 724px;
  padding: 47px 40px 40px 48px;
  background-color: $c-tour-bg-yellow;
  background-image: url('../../../static/images/tour/bg-flower-y.png');
  .info-content {
    padding: 0;
  }
  .nav-map-info-title {
    display: inline-block;
    background-image: url('../../../static/images/public/left-big.png'),
      url('../../../static/images/public/right-big.png');
    background-repeat: no-repeat;
    background-position: 0 0, 100% 100%;
    background-size: contain;
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 34px;
    padding: 0 36px;
  }
  .nav-map-info-description {
    color: $c-white;
    line-height: 2.2;
    font-size: 14px;
    > li {
      margin-bottom: 20px;
      position: relative;
    }
    .s-circular {
      margin-right: 10px;
    }
    .info-title {
      font-size: 16px;
    }
    .info-css {
      text-align: justify;
      padding-left: 20px;
      -o-text-overflow: ellipsis; /* Opera 9-10 */
      text-overflow: ellipsis;
      white-space: wrap;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
    }
    .more {
      top: 8px;
      right: 0;
    }
  }
}
.more {
  overflow: hidden;
  height: 34px;
  line-height: 33px !important;
  font-size: 15px !important;
  width: 113px;
  span {
    line-height: 33.5px !important;
  }
}
.see-more {
  top: 47px;
  right: 40px;
  span {
    line-height: 33px !important;
  }
  .iconfont {
    font-size: 20px;
  }
}
.iconfont {
  margin-left: 6px;
  font-size: 22px;
}

.next-prev-btns {
  padding: 0 40px 0 65px;
  left: 0;
  bottom: 22px;
  .next,
  .prev {
    background-repeat: no-repeat;
    line-height: 17px;
    font-size: 14px;
  }
  .next {
    padding-right: 25px;
    background-position: 100% 100%;
    background-image: url('../../../static/images/public/arrow-right-border.png');
  }
  .prev {
    padding-left: 25px;
    background-position: 0 0;
    background-image: url('../../../static/images/public/arrow-left-border.png');
  }
}
.introduce {
  max-height: 210px;
  overflow: hidden;
}
// 动画
.ball-scale-ripple-multiple {
  position: absolute;
  bottom: -5px;
  left: -10px;

  -webkit-transform: translateY(-25px);
  -ms-transform: translateY(-25px);
  transform: translateY(-25px);
  > div {
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 2px solid $c-red;
    -webkit-animation: ball-scale-ripple-multiple 1.25s 0s infinite
      cubic-bezier(0.21, 0.53, 0.56, 0.8);
    animation: ball-scale-ripple-multiple 1.25s 0s infinite
      cubic-bezier(0.21, 0.53, 0.56, 0.8);
    &:nth-child(1) {
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
    }
    &:nth-child(2) {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      -webkit-animation-delay: 0.4s;
      animation-delay: 0.4s;
    }
  }
}
@keyframes ball-scale-ripple-multiple {
  0% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
</style>
